export const DASHBOARD_CHARTS = {
  soil: [
    'irrigation', // Kc y mm
    'stackedSoilMoisture', // Humedad de suelo
    'soilMoisture', // Sumatoria humedad de suelo
    'roots', // Profundidad riego y raíces
  ],
  plant: [
    'irrigation', // Kc y mm
    'soilMoisture', // Sumatoria humedad de suelo
    'plants', // Dendrómetro de brote
  ],
};

export type DashboardType = keyof typeof DASHBOARD_CHARTS;

export const getChartsForDashboard = (
  dashboardType: DashboardType,
): string[] => DASHBOARD_CHARTS[dashboardType] || [];

export const getDashboardFromCharts = (selectedCharts: string[]): DashboardType | null => {
  const soilCharts = DASHBOARD_CHARTS.soil;
  const plantCharts = DASHBOARD_CHARTS.plant;

  const isSoilDashboard = soilCharts.every((chart) => selectedCharts.includes(chart))
    && soilCharts.length === selectedCharts.length;
  const isPlantDashboard = plantCharts.every((chart) => selectedCharts.includes(chart))
    && plantCharts.length === selectedCharts.length;

  if (isSoilDashboard) return 'soil';
  if (isPlantDashboard) return 'plant';
  return null;
};
